//Please add the language resource
const settlementCostIncomeReport = {
  customerOrderNo: 'customerOrderNo',
  orderDate: 'orderDate',
  projectCode: 'projectCode',
  projectName: 'projectName',
  costCode: 'costCode',
  costName: 'costName',
  shipperCode: 'shipperCode',
  shipperName: 'shipperName',
  soOrSto: 'soOrSto',
  checkoutMethod: 'checkoutMethod',
  originAddrCode: 'originAddrCode',
  originAddrName: 'originAddrName',
  originAddrProvinceName: 'originAddrProvinceName',
  originAddrCityName: 'originAddrCityName',
  destAddrName: 'destAddrName',
  destAddrCode: 'destAddrCode',
  destAddrProvinceName: 'destAddrProvinceName',
  destAddrCityName: 'destAddrCityName',
  destAddrLocation: 'destAddrLocation',
  totalQty: 'totalQty',
  totalWeight: 'totalWeight',
  totalVolume: 'totalVolume',
  carrierNo: 'carrierNo',
  carrierName: 'carrierName',
  deliverGoodsTime: 'deliverGoodsTime',
  transTypeName: 'transTypeName',
  dispatchRemark: 'dispatchRemark',
  costFreight: 'costFreight',
  costDeliveryFee: 'costDeliveryFee',
  costDeliveryCharge: 'costDeliveryCharge',
  costPackageFare: 'costPackageFare',

  costElseExpense: 'costElseExpense',
  costTotalExpense: 'costTotalExpense',
  checkoutStatus: 'checkoutStatus',

  costRemark: 'costRemark',
  incomeFreight: 'incomeFreight',
  incomeUpstairsFee: 'incomeUpstairsFee',
  incomeTerminalCharges: 'incomeTerminalCharges',
  incomeValueAddedIncome: 'incomeValueAddedIncome',
  incomeElseIncome: 'incomeElseIncome',
  incomeRemark: 'incomeRemark',
  gross: 'gross',
  grossRate: 'grossRate',
  settlementClosingFlag: 'settlementClosingFlag',
  closeMonth: 'closeMonth',
};
export default settlementCostIncomeReport



// WEBPACK FOOTER //
// ./src/page/settlementFee/settlementCostIncomeReport/lang/settlementCostIncomeReport.en.js